export default __webpack_public_path__ + "static/media/our-services-home-care-respite-care-01.13585e6d.jpg";